import styled from "@emotion/styled";
import { NumberAProps } from "@src/ruix/types";

const NumberA = (props: NumberAProps) => {
	const number = props.number;

	const numWithZero = number < 10 ? `0${number}` : number;
	const size = props.size || "medium";

	return <NumberAComponent className={[size].join(" ")}>{numWithZero}</NumberAComponent>;
};

const NumberAComponent = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	color: white;
	background-color: var(--primary);
	border-radius: 50%;
	padding: 6px;
	line-height: 1;

	&.xsmall {
		font-size: 12px;
	}

	&.small {
		font-size: 14px;
	}

	&.medium {
		font-size: 16px;
	}

	&.large {
		font-size: 18px;
	}
`;

export default NumberA;
